import AxiosAPI from '../../../utils/AxiosAPI';

// Get Customer Details by Id
export const handleGetCustomerDetails = (agencyId, customerId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${agencyId}/${customerId}/details`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Get Package pricing
export const handleLoadPricing = (userId, productId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/get-pricing/${userId}/${productId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// -- Change Product Logo
export const handleChangeProfileLogoOpe = (id, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`api/customers/${id}/change-profile-image `)
            .put(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Create service buy invoice
export const ApiCreateServiceBuyInvoice = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/purchase/service/create-invoice`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Get Service List by User Id, Product Id and Package Id
export const ApiGetPricingServiceList = (userId, productId, packageId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/invoices/get-pricing-services/${userId}/${productId}/${packageId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// -- Update Customer Bill To Setting
export const handleUpdateCustomerBillTo = (customerId, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/bill-to`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
